import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './style.css';


ReactDOM.render(
  <React.StrictMode>
  <>
   <div className="wrapper">
        <div className="top-text">
            <h1>GCLD Email Signature</h1>
            <p style={{lineHeight: "1.6"}}>
                We are standardizing GCLD email signatures to enhance consistency and impact in our communications. To update your signature, please enter your information below, click 'Copy', paste it into your email settings, and save it.
            </p>
            <p style={{lineHeight: "1.6"}}><strong>Note:</strong> If you're using Proofpoint URL Isolation, the 'Copy' button may not work properly. For best results, click Exit in the top right corner before continuing.</p>
        </div>
        <div className="white-box">
        	<App/>
        </div> 
    </div>
    </>
  </React.StrictMode>,
  document.getElementById('root')
);
